export const CHECK_API_KEY_RESOURCE_TYPE = 'EOC_CHECK_API_KEY';
